module.exports = __webpack_public_path__ + "img/bottom_texture.f4839cb8.png";